// extracted by mini-css-extract-plugin
module.exports = {"container":"gravity-right_container_1ZRGX","noDataBox":"gravity-right_noDataBox_2kTuH","icon":"gravity-right_icon_2A-PZ","chartBox":"gravity-right_chartBox_3lgVn"};